import { render, staticRenderFns } from "./AlertDataTest.vue?vue&type=template&id=5e3e7b22&scoped=true"
import script from "./AlertDataTest.vue?vue&type=script&lang=js"
export * from "./AlertDataTest.vue?vue&type=script&lang=js"
import style0 from "./AlertDataTest.vue?vue&type=style&index=0&id=5e3e7b22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3e7b22",
  null
  
)

export default component.exports